export const editExerciseFields = [
	{
		name: "monday",
		label: "Monday",
		placeholder: "Monday"
	},
	{
		name: "tuesday",
		label: "Tuesday",
		placeholder: "Tuesday"
	},
	{
		name: "wednesday",
		label: "Wednesday",
		placeholder: "Wednesday"
	},
	{
		name: "thursday",
		label: "Thursday",
		placeholder: "Thursday"
	},
	{
		name: "friday",
		label: "Friday",
		placeholder: "Friday"
	},
	{
		name: "saturday",
		label: "Saturday",
		placeholder: "Saturday"
	},
	{
		name: "sunday",
		label: "Sunday",
		placeholder: "Sunday"
	}
];
